export enum HealthIndexStatus {
  Ok = "normal",
  Warning = "warning",
  Alarm = "alarm"
}
